import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { connect } from 'react-redux'
import MenuItem from '@material-ui/core/MenuItem'
import isEmpty from 'lodash.isempty'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_POSITIVE_INTEGER,
  VALIDATOR_IS_SISENSE_REFRESH,
} from 'validation'
import Input from 'components/common/Form/Input'
import TextArea from 'components/common/Form/TextArea'
import { Select } from 'components/common/FormInputs'
import { APP_LANGUAGES } from 'constants/index'
import messages from './translate'

class SisenseForm extends Component {
  getFormData = sisense => {
    let formData = {
      orderNumber: 0,
    }

    if (!isEmpty(sisense)) {
      const {
        embedLink,
        parameters,
        orderNumber,
        refreshInterval,
        refreshTriggerInterval,
        slug,
        application,
        translations,
      } = sisense

      formData = {
        translations,
        embedLink,
        parameters: JSON.stringify(parameters),
        orderNumber,
        refreshInterval: refreshInterval || null,
        licenseeApplication: !isEmpty(application) ? application.id : null,
        refreshTriggerInterval: refreshTriggerInterval || null,
        slug,
      }
    }

    return formData
  }

  render() {
    const {
      formData: { sisense, applications },
      intl: { formatMessage },
      onSubmit,
    } = this.props
    const initialValues = this.getFormData(sisense)

    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} className="form-basic">
            <div className="form-group">
              {Object.values(APP_LANGUAGES).map(({ key }) => (
                <Field
                  name={`translations[${key}][name]`}
                  key={`${key}_name`}
                  type="text"
                  label={`${key} ${formatMessage(messages.name)}`}
                  component={Input}
                  className="form-control"
                  disabled={submitting}
                  required={key === 'en'}
                  validate={
                    key === 'en' ? getValidator(VALIDATOR_IS_EMPTY) : null
                  }
                />
              ))}
              <div className="form-group">
                <Field
                  name="licenseeApplication"
                  component={Select}
                  label={formatMessage(messages.application)}
                  disabled={submitting}
                  required
                  formControlProps={{
                    fullWidth: true,
                    required: true,
                  }}>
                  {applications.map((application, index) => (
                    <MenuItem
                      key={`${application.id}_${index}`}
                      component="li"
                      button
                      value={application.id}>
                      {application.appName}
                    </MenuItem>
                  ))}
                </Field>
              </div>
              <Field
                name="embedLink"
                type="text"
                label={formatMessage(messages.embedLink)}
                component={Input}
                disabled={submitting}
              />
              <Field
                name="parameters"
                type="text"
                label={formatMessage(messages.parameters)}
                component={TextArea}
                disabled={submitting}
              />
              <Field
                name="orderNumber"
                type="number"
                label={formatMessage(messages.order)}
                component={Input}
                disabled={submitting}
                required
                validate={getValidator(VALIDATOR_IS_EMPTY)}
              />
              <Field
                name="refreshInterval"
                type="number"
                label={formatMessage(messages.refreshInterval)}
                component={Input}
                disabled={submitting}
                validate={getValidator(VALIDATOR_IS_POSITIVE_INTEGER)}
              />
              <Field
                name="refreshTriggerInterval"
                type="number"
                label={formatMessage(messages.refreshTriggerInterval)}
                component={Input}
                disabled={submitting}
                validate={getValidator(VALIDATOR_IS_SISENSE_REFRESH)}
              />
              <Field
                name="slug"
                type="string"
                label={formatMessage(messages.slug)}
                component={Input}
                disabled={submitting}
              />
            </div>
            <div className="form-group buttons">
              <Button
                href={null}
                type="submit"
                color="primary"
                size="medium"
                variant="contained"
                onClick={handleSubmit}
                disabled={submitting}>
                {formatMessage(messages.saveInfo)}
              </Button>
            </div>
          </form>
        )}
      />
    )
  }
}

SisenseForm.propTypes = {
  formData: PropTypes.shape({
    sisense: PropTypes.object,
    applications: PropTypes.array,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

SisenseForm.defaultProps = {
  intl: {
    formatMessage: () => '',
  },
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    loading: state.getIn(['sisense', 'loading']),
  }),
  null,
)(injectIntl(SisenseForm))
